import { ValueRanges } from 'rlv-common';
import { ViewName } from '../../../../helpers/ViewName';
import { ConstantNeedBlockData } from '../../../../pages/needs/Needs.types';
import NeedsPageContainer from '../../../../pages/needs/NeedsPageContainer';
import { getAngebot, updateConstantNeedBlockData } from '../../../../services/api';
import {
  getTrackingBirthdate,
  mapFetchedNeedData,
  mapTrackingInsuredPerson,
} from '../../../../tracking/trackingFormating';
import { PagePercentage } from '../../../../types/PagePercentage';
import { createNeedPageSchema } from '../../../../validation/NeedPage';
import { FetchedTrackingData, StateDefinition } from '../../../StateMachine';
import { NavigationAction, StateName } from '../../../StateMachineTypes';

export const constantYearsTermState: StateDefinition<ConstantNeedBlockData> = {
  name: StateName.CONSTANT_YEARS_TERM,
  percentage: PagePercentage.CONSTANT_YEARS_TERM,
  trackingViewName: ViewName.BEDARFSANALYSE,
  createValidationSchema: (valueRanges: ValueRanges) => createNeedPageSchema(valueRanges),
  validInboundStates: [StateName.CONSTANT_SUM_INSURED, StateName.LIVING_CONDITIONS_EMPLOYMENT],
  transitions: [
    {
      test: action => {
        const backAction =
          action === NavigationAction.BACK || action === NavigationAction.BROWSER_BACK;
        return backAction;
      },
      newState: StateName.CONSTANT_SUM_INSURED,
    },
    {
      test: action => action === NavigationAction.NEXT,
      newState: StateName.LIVING_CONDITIONS_EMPLOYMENT,
    },
  ],
  onEnter: async (_, inputData) => {
    const response = await getAngebot(inputData.businessId);

    const fetchedTrackingData: FetchedTrackingData = {
      userAttributes: {
        ...mapTrackingInsuredPerson(),
        ...getTrackingBirthdate(response.livingConditionsModel),
      },
      tariffOptions: {
        ...mapFetchedNeedData(response.needSelectionModel),
      },
    };

    if (response.feeCalculationModel) {
      fetchedTrackingData.tariffOptions!.VersSum = response.feeCalculationModel.sumInsured;
    }

    return {
      userInput: response.constantNeedModel,
      valueRanges: response.valueRanges,
      fetchedTrackingData,
    };
  },
  onExit: async (_, inputData) => {
    await updateConstantNeedBlockData(inputData.businessId, inputData.userInput);
    return {};
  },

  render: (inputData, handleAction, updateApp, _unused, updateDTMTracking) => {
    const userInput: ConstantNeedBlockData = inputData.userInput;
    return (
      <NeedsPageContainer
        businessId={inputData.businessId}
        inputData={inputData}
        updateApp={updateApp}
        storeState={{
          periodInYears: userInput.periodInYears,
          // We really need to send this values to update the tracker
          sumInsured: userInput.sumInsured,
          update: values => updateApp(values),
        }}
        valueRanges={inputData.valueRanges}
        handleAction={handleAction}
        updateDTMTracking={updateDTMTracking}
      />
    );
  },
};
